// Source: https://newbedev.com/how-to-refresh-page-on-back-button-click
window.onpageshow = function(event) {
	if (event.persisted) window.location.reload();
};